import { Extension } from "@tiptap/core"
import { Plugin, PluginKey } from "prosemirror-state"

const COLOR_STYLE_PROPERTIES = [
  "color",
  "background",
  "background-color",
  "-webkit-text-fill-color"
] as const

const stripColorStyles = (html: string): string => {
  if (!html || typeof DOMParser === "undefined") return html
  if (html.includes("data-pm-slice")) return html

  const doc = new DOMParser().parseFromString(html, "text/html")

  doc.body.querySelectorAll("*").forEach(el => {
    const htmlEl = el as HTMLElement
    if (!htmlEl.style) return

    COLOR_STYLE_PROPERTIES.forEach(prop => {
      if (htmlEl.style.getPropertyValue(prop)) {
        htmlEl.style.removeProperty(prop)
      }
    })

    if (htmlEl.getAttribute("style")?.trim() === "") {
      htmlEl.removeAttribute("style")
    }
  })

  return doc.body.innerHTML
}

export const PasteColorSanitizer = Extension.create({
  name: "pasteColorSanitizer",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("pasteColorSanitizer"),
        props: {
          transformPastedHTML(html: string) {
            return stripColorStyles(html)
          }
        }
      })
    ]
  }
})
